<template>
    <div>
        <Popup v-model="keyboardShow" position="bottom" :style="{ height: '0' }" >
            <NumberKeyboard
                :show="keyboardShow"
                extra-key="X"
                close-button-text="完成"
                @blur="numberKeyboardBlur"
                @input="onInput"
                @delete="onDelete"
                @close="onClose"
                >
                <template #title-left>
                    <div class="key-board">
                        <el-input 
                            :class="{'activeInput': index == actionIdNumberIndex}"
                            :readonly="true"
                            :ref="`keyBoard${index}`"
                            :maxLength="1" 
                            v-for="(item,index) in 16" 
                            :key="index" 
                            v-model="idNumber[index]" 
                            @focus="idNumberfocus(index)"
                            @blur="idNumberBlur(index)"
                        >
                        {{ actionIdNumberIndex }}-{{index}}
                        </el-input>
                    </div>
                </template>
            </NumberKeyboard>
        </Popup>
    </div>
</template>
<script>
    import NumberKeyboard from 'vant/lib/number-keyboard';
    import 'vant/lib/number-keyboard/style';
    import Popup from 'vant/lib/popup';
    import 'vant/lib/popup/style';
    export default {
        name: 'IDNumberKeyboard',
        components: {
            NumberKeyboard,
            Popup
        },
        props: {
            userAnswer: {
                default: ''
			},
        },
        data() {
            return {
                keyboardShow: false,
                idNumber: Array(16).fill(''),
                actionIdNumberIndex: -1,
                editNum: 0
            }
        },
        methods: {
            onInput(value) {
                console.log('this.editNum :>> ', this.editNum);
                console.log('this.actionIdNumberIndex != this.userAnswer.length - 1 :>> ', this.actionIdNumberIndex, this.userAnswer.length);
                
                if (this.editNum == 0 && (this.actionIdNumberIndex < 16)) {
                    this.actionIdNumberIndex++
                    this.$refs[`keyBoard${this.actionIdNumberIndex}`][0].focus()
                    console.log('this.actionIdNumberIndex :>> ', this.actionIdNumberIndex);
                }
                if (this.actionIdNumberIndex != -1) {
                    this.$set(this.idNumber, this.actionIdNumberIndex, value)
                }
                this.editNum = 0
            },
            onClose() {
                // this.data.userAnswer = this.idNumber.join('')
                this.idNumber = this.idNumber.slice(0,16)
                this.$emit('updata', this.idNumber.join(''))
                this.idNumber = Array(16).fill('')
                this.keyboardShow = false
            },
            keyboardShowClick() {
                this.idNumber = this.userAnswer.split('')
                this.actionIdNumberIndex = this.userAnswer.length > 0 ? this.userAnswer.length - 1 : 0
                this.keyboardShow = true
                this.editNum = 1
            },
            onDelete() {
                if (this.actionIdNumberIndex != -1) {
                    this.$set(this.idNumber, this.actionIdNumberIndex, '')
                    this.actionIdNumberIndex--
                }
            },
            idNumberfocus(index) {
                this.actionIdNumberIndex = index
            },
            idNumberBlur(index) {
                this.editNum = 1
                if (this.actionIdNumberIndex && this.actionIdNumberIndex == index){
                    this.actionIdNumberIndex = -1
                }
            },
            numberKeyboardBlur() {
                this.idNumber = []
            },
        }
    }
</script>

<style lang="scss" scoped>
.key-board{
    display: flex;
    width: calc(100% - 60px);
    padding-left: 10px;
    /deep/.el-input__inner{
        padding: 0;
        text-align: center;
    }
}
.activeInput {
    /deep/.el-input__inner{
        border-color: #409EFF !important;
    }
}
/deep/.el-input__inner:focus{
    border-color: #DCDFE6;
}
</style>